import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { ApplicationState } from "../../../redux/ApplicationState";
import Faqs from "../components/Faqs";
import { getFrequentlyAskedQuestion } from "../../../actions/Faqs";
import { UserPageTrack } from "../../../models/User";
import { postUserPageTrack } from "../../../actions/UserAction";

const mapStateToProps = ({
  frequentlyAskedQuestionState
}: ApplicationState) => ({
  faqData: frequentlyAskedQuestionState.response
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<ApplicationState, Record<string, never>, any>
) => {
  return {
    getFrequentlyAskedQuestion: () => {
      dispatch(getFrequentlyAskedQuestion());
    },
    postUserPageTrack: (payload: UserPageTrack) => {
      dispatch(postUserPageTrack(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Faqs);
